// Guardian (M18.1 ocean monument). PURE (ENG-1). The three signature guardian
// mechanics, as pure rules the host drives each tick:
//  • the charge-up laser beam — it charges only while line of sight to its target
//    holds, resets the instant sight breaks, and discharges its hit at full charge;
//  • defensive spikes — a melee attacker is thorned back while a guardian's spikes
//    are extended (which they are whenever it is not actively swimming at prey);
//  • the elder guardian's Mining Fatigue aura, projected on every nearby player.
import { GUARDIAN } from '../config';

/** Advance a guardian's beam charge: +1 per tick while it holds line of sight to a
 *  target in range, reset to 0 the moment sight (or range) breaks. Clamped full. */
export function beamCharge(prev: number, hasLineOfSight: boolean, dist: number): number {
  if (!hasLineOfSight || dist > GUARDIAN.BEAM_RANGE) return 0;
  return Math.min(GUARDIAN.BEAM_CHARGE_TICKS, prev + 1);
}

/** The beam discharges (deals its hit) on the tick it reaches full charge. */
export function beamFires(charge: number): boolean {
  return charge >= GUARDIAN.BEAM_CHARGE_TICKS;
}

/** Beam damage — the elder guardian's beam hits harder. */
export function beamDamage(elder: boolean): number {
  return elder ? GUARDIAN.ELDER_BEAM_DAMAGE : GUARDIAN.BEAM_DAMAGE;
}

/** A guardian extends its spikes whenever it is not swimming at prey — that is
 *  when it is charging a beam or idle — so that is when melee gets thorned. */
export function spikesOut(charge: number, swimmingAtPrey: boolean): boolean {
  return charge > 0 || !swimmingAtPrey;
}

/** Thorn damage reflected onto a melee attacker while the spikes are extended. */
export function spikeThorns(elder: boolean, spikes: boolean): number {
  if (!spikes) return 0;
  return elder ? GUARDIAN.ELDER_SPIKE_DAMAGE : GUARDIAN.SPIKE_DAMAGE;
}

/** An elder guardian projects Mining Fatigue on any player within its aura. */
export function elderInflictsFatigue(dist: number): boolean {
  return dist <= GUARDIAN.FATIGUE_RANGE;
}

/** Mining Fatigue amplifier (0-based → III) the elder aura applies. */
export function fatigueAmplifier(): number { return GUARDIAN.FATIGUE_AMPLIFIER; }
/** Duration (ticks) of the Mining Fatigue the elder aura applies. */
export function fatigueTicks(): number { return GUARDIAN.FATIGUE_TICKS; }
/** Whether this world tick is an elder-aura reapplication tick. */
export function fatigueReapplies(worldTick: number): boolean {
  return worldTick % GUARDIAN.FATIGUE_INTERVAL === 0;
}

/** A guardian out of water dries out, taking a point of damage on this cadence. */
export function guardianDrying(inWater: boolean, worldTick: number): boolean {
  return !inWater && worldTick % GUARDIAN.DRY_INTERVAL === 0;
}
